import React, { forwardRef } from "react";
import { cn } from "@/lib/utils";

interface LayoutProps {
  children: React.ReactNode;
  className?: string;
  fullWidth?: boolean;
}

/**
 * Layout component that provides consistent margins and max-width across the application
 * @param children - The content to be rendered inside the layout
 * @param className - Additional classes to apply to the layout
 * @param fullWidth - Whether the layout should take up the full width of the screen
 */
export const Layout: React.FC<LayoutProps> = ({
  children,
  className,
  fullWidth = false,
}) => {
  return (
    <div
      className={cn(
        "mx-auto",
        fullWidth ? "w-full" : "max-w-7xl xl:max-w-[1536px] px-4 md:px-6 lg:px-8",
        className
      )}
    >
      {children}
    </div>
  );
};

export default Layout; 